// extracted by mini-css-extract-plugin
export var body = "_k4-0";
export var sectionHeader = "_k4-4";
export var shortcutColumns = "_k4-2";
export var shortcutList = "_k4-1";
export var shortcutSection = "_k4-3";